import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { TagWithClassrooms } from '@teetsh/app/src/containers/MesAnneesScolaires/School/Tags/types';

export const TAGS_KEY = 'tags';

function getTags({
  schoolyearId,
  schoolId,
}: {
  schoolyearId: string;
  schoolId: string;
}) {
  return request(`/schoolyears/${schoolyearId}/schools/${schoolId}/tags`, {
    method: 'GET',
  }).then<TagWithClassrooms[]>(res => res.data);
}

export default function useTags(props: {
  schoolyearId: string;
  schoolId: string;
}) {
  const { schoolyearId, schoolId } = props;
  return useQuery({
    queryKey: [schoolyearId, schoolId, TAGS_KEY],
    queryFn: () => getTags({ schoolyearId, schoolId }),
    refetchOnWindowFocus: false,
    retry: 1,
  });
}
